import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      staticStyle: { "z-index": "1000" },
      attrs: { fullscreen: _vm.$vuetify.breakpoint.xsOnly },
      model: {
        value: _vm.editDialog,
        callback: function ($$v) {
          _vm.editDialog = $$v
        },
        expression: "editDialog",
      },
    },
    [
      _c(
        VCard,
        [
          _c(
            VCardTitle,
            { staticClass: "d-flex" },
            [
              _c("span", { staticClass: "flex-grow-1" }, [
                _vm._v(
                  _vm._s(_vm.$vuetify.lang.t("$vuetify.worksheet.worksheet")) +
                    " " +
                    _vm._s(_vm.$vuetify.lang.t("$vuetify.base.notes"))
                ),
              ]),
              _c(
                VBtn,
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c(VIcon, [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            VCardText,
            [
              _c(VTextarea, {
                staticClass: "my-4",
                attrs: {
                  placeholder: _vm.$vuetify.lang.t(
                    "$vuetify.worksheet.noteInstruction"
                  ),
                  outlined: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.notes,
                  callback: function ($$v) {
                    _vm.notes = $$v
                  },
                  expression: "notes",
                },
              }),
              _vm.images && _vm.images.length > 0
                ? _c(
                    VRow,
                    _vm._l(_vm.images, function (img, index) {
                      return _c(
                        VCol,
                        { key: index, attrs: { cols: "1", md: "2", lg: "3" } },
                        [
                          _c(VImg, {
                            attrs: {
                              height: "100px",
                              contain: "",
                              "aspect-ratio": "1.7",
                              src: img.src,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "placeholder",
                                  fn: function () {
                                    return [
                                      _c(
                                        VRow,
                                        {
                                          staticClass: "fill-height ma-0",
                                          attrs: {
                                            align: "center",
                                            justify: "center",
                                          },
                                        },
                                        [
                                          _c(VProgressCircular, {
                                            attrs: {
                                              indeterminate: "",
                                              color: "grey lighten-5",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c(
                            "div",
                            { staticClass: "text-center text-caption ma-2" },
                            [_vm._v(_vm._s(_vm._f("formatDateTime")(img.time)))]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "d-flex justify-center" },
                [
                  !_vm.submitted
                    ? _c("image-upload", {
                        staticClass: "mt-4 mx-2",
                        attrs: { loading: _vm.loading },
                        model: {
                          value: _vm.files,
                          callback: function ($$v) {
                            _vm.files = $$v
                          },
                          expression: "files",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCardActions,
            { staticClass: "justify-center py-6" },
            [
              _c(
                VBtn,
                {
                  staticClass: "mx-2",
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$vuetify.lang.t("$vuetify.base.cancel")) + " "
                  ),
                ]
              ),
              _c(
                VBtn,
                {
                  staticClass: "mx-2",
                  attrs: { color: "primary" },
                  on: { click: _vm.saveNotes },
                },
                [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.submit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }